// vim: set ts=2 sw=2 et ft=javascript:
/*
 * Copyright (C) 2011 Minted LLC
 *
 * All Rights Reserved
 *
 * Favorite designer (Bug 5925)
 */

/*
  UMD header generated via modularize.js at 2015-04-14T23:57:21.235Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/jquery-1.9.1.min': '$'
})(this, function (m_module, $) {

var M = m_module.M;

if (typeof M == "undefined") {
  var M = {};
}

/**
 * My favorite designers
 * @see Bug 5925
 */
M.favoriteDesignerAttach = function(id) {
  $('#'+id).each(function() {
    var thisJq = $(this),
    no = thisJq.find('.no'),
    yes = thisJq.find('.yes'),
    classes = this.className.split(' '),
    designerUid = null;

    for (var i = classes.length-1; i >= 0; --i) {
      if (/^designer-/.test(classes[i])) {
        designerUid = classes[i].split('-', 2)[1];
      }
    }

    // It is not possible to un-favorite a designer from here per
    // https://bugs.minted.com/show_bug.cgi?id=5925#c11
    no.find('a').click(function() {
      $.ajax({
        type: 'POST',
        url: '/favorite_designers/toggle',
        data: {
          'action': 'add',
          'uid': designerUid
        },
        success: function(data, textStatus, jqXHR) {
          $('.favorite-designer .no').fadeOut('', function() {
            $('.favorite-designer .yes').fadeIn();
          });
        },
        dataType: 'json'
      });
      return false;
    });
  });
};

return {
  'M': M
};

});
